import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";

interface RequestListHeaderProps {
  selectedCount: number;
  onSelectAll: () => void;
  onMarkAsRead: () => void;
  onMarkAsUnread: () => void;
  isAllSelected: boolean;
  currentPage: number;
  totalItems: number;
  endItem: number;
  onPrevious: () => void;
  onNext: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
}

export function RequestListHeader({
  selectedCount,
  onSelectAll,
  onMarkAsRead,
  onMarkAsUnread,
  isAllSelected,
  currentPage,
  totalItems,
  endItem,
  onPrevious,
  onNext,
  hasNext,
  hasPrevious,
}: RequestListHeaderProps) {
  return (
    <div className="flex items-center justify-between px-5 py-3">
      {/* Left side - Controls */}
      <div className="flex items-center gap-6">
        {/* Select All Checkbox */}
        <Checkbox
          checked={isAllSelected}
          onCheckedChange={onSelectAll}
          className={`h-5 w-5 border-white ${
            isAllSelected
              ? "border-orange-500 bg-orange-500"
              : "bg-transparent hover:border-gray-400"
          }`}
        />

        <div className="flex gap-3">
          {/* Refresh Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => window.location.reload()}
            className="hover:bg-dark-surface h-8 w-8 text-white hover:text-white"
          >
            <i className="ri-reset-right-line text-md mt-0.5"></i>
          </Button>

          {/* Mark as Read Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onMarkAsRead}
            disabled={selectedCount === 0}
            className="hover:bg-dark-surface h-8 w-8 text-white hover:text-white disabled:opacity-50"
            title="Mark as read"
          >
            <i className="ri-mail-open-line text-md"></i>
          </Button>

          {/* Mark as Unread Button */}
          <Button
            variant="ghost"
            size="icon"
            onClick={onMarkAsUnread}
            disabled={selectedCount === 0}
            className="hover:bg-dark-surface h-8 w-8 text-white hover:text-white disabled:opacity-50"
            title="Mark as unread"
          >
            <i className="ri-mail-unread-line text-md"></i>
          </Button>
        </div>

        {/* Selected count indicator */}
        {selectedCount > 0 && (
          <span className="text-sm text-white">{selectedCount} selected</span>
        )}
      </div>

      {/* Right side - Pagination */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={onPrevious}
            disabled={!hasPrevious}
            className="hover:bg-dark-surface h-8 w-8 text-white hover:text-white/90 disabled:opacity-30"
          >
            <i className="ri-arrow-left-s-fill text-lg"></i>
          </Button>
          <span className="text-sm leading-normal text-white">
            {currentPage} - {endItem} of {totalItems}
          </span>

          <Button
            variant="ghost"
            size="icon"
            onClick={onNext}
            disabled={!hasNext}
            className="hover:bg-dark-surface h-8 w-8 text-white hover:text-white/90 disabled:opacity-30"
          >
            <i className="ri-arrow-right-s-fill text-lg"></i>
          </Button>
        </div>
      </div>
    </div>
  );
}
